import React, { useMemo, useState, useEffect } from "react";
import { Table } from "../../components/Table/Table";
import { view_icon } from "../../assets/imgs";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useNavigate } from "react-router-dom";
import { useLazyLightningDeviceListQuery } from "../redux/api/api";
import apiRequest from "../redux/api/apiRequest";
import moment from "moment";


const LightningDevice = () => {

    const navigate = useNavigate();

    const [list, setList] = useState([]);

    const [getLightningDevices, { isLoading }] = useLazyLightningDeviceListQuery();

    useEffect(() => {
        getDevices();
    }, []);





    const getDevices = async () => {

        const res = await apiRequest(getLightningDevices);

        console.log("API Response:", res);

        const deviceList =
            res?.lightning_device_list ||
            res?.data?.lightning_device_list ||
            [];

        if (res?.status === "success" || res?.data?.status === "success") {

            const formattedData = deviceList.map((item) => ({
                id: item.id,
                device_name: item.device_name,
                device_code: item.device_code,
                assigned: { name: item.user_id || "--" },
                location: { name: item.location_id || "--" },
                device_status: item.device_status,
                // heart_beat: item?.heart_beat
            }));

            setList(formattedData);
        }
    };


    const columns = useMemo(() => [
        {
            Header: "S.No",
            accessor: "id",
            Cell: ({ row }) => {
                return <p>{row.index + 1}</p>;
            }
        },

        {
            Header: "Device Name",
            accessor: "device_name",
            Cell: ({ value }) => {
                return <p>{value}</p>;
            }
        },

        {
            Header: "Device ID",
            accessor: "device_code",
            Cell: ({ value }) => {
                return <p>{value}</p>;
            }
        },

        {
            Header: "Assigned",
            accessor: "assigned.name",
            Cell: ({ value }) => {
                return <p>{value ? value : "--"}</p>;
            }
        },

        {
            Header: "Location",
            accessor: "location.id",
            Cell: ({ value }) => {
                return <p>{value ? value : "--"}</p>;
            }
        },

        {
            Header: "Notification Report",
            accessor: "",
            Cell: ({ row }) => {
                return (
                    <button
                        onClick={() => {
                            navigate("/lightning-notification-report", {
                                state: { data: row.original }
                            });
                        }}
                        className="cust-btn"
                    >
                        <img src={view_icon} alt="view" className="mx-2 edit-btn" />
                    </button>
                );
            }
        },

        {
            Header: "Device Status",
            accessor: "device_status",
            Cell: ({ value, row }) => {
                return (
                    <div>
                        <button className={`border-0 toggle-btn cust-btn `}>
                            {value == 1 ? (
                                <div>
                                    <FavoriteIcon className="green" />
                                </div>
                            ) : (
                                <div>
                                    <FavoriteIcon className="red" />
                                </div>
                            )}
                        </button>
                    </div>
                );
            },
        },


    ], [navigate]);

    return (
        <div className="dashRightView home_section">

            <div className="d-flex ac-jb">
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary">
                    Lightning Device List
                </h2>
            </div>

            <Table
                columns={columns}
                data={list}
                show={false}
                loading={isLoading}

            />

        </div>
    );
};

export default LightningDevice;